// ФАЙЛ УПРАВЛЯЕТСЯ ШАБЛОНОМ! НЕ ИЗМЕНЯЙТЕ ЕГО ВРУЧНУЮ!
import { useRuntimeConfig } from 'virtual:runtime-config';

import { makeSingleton } from '@/shared/utils/makeSingleton';

import { MF_NAME } from './env';
import { type RuntimeConfig, type RuntimeConfigBase, initRuntimeConfigExtends } from './runtimeExtends';

const initRuntimeConfig = (): RuntimeConfig => {
  const runtimeConfig = useRuntimeConfig()[MF_NAME] as Partial<RuntimeConfigBase> | undefined;

  if (!runtimeConfig) {
    throw new Error(`Runtime config namespace "${MF_NAME}" was not found`);
  }

  const soguServiceUrl = runtimeConfig.VITE_RUNTIME_SOGU_SERVICE_URL;

  if (!soguServiceUrl) {
    throw new Error('Missing runtime config field: VITE_RUNTIME_SOGU_SERVICE_URL');
  }

  runtimeConfig.VITE_RUNTIME_SOGU_SERVICE_URL = soguServiceUrl;
  runtimeConfig.VITE_RUNTIME_SENTRY_DSN = runtimeConfig.VITE_RUNTIME_SENTRY_DSN ?? '';
  runtimeConfig.VITE_RUNTIME_SEARCH_API_URL = runtimeConfig.VITE_RUNTIME_SEARCH_API_URL ?? '';
  runtimeConfig.VITE_RUNTIME_AUDIOGUIDES_URL = runtimeConfig.VITE_RUNTIME_AUDIOGUIDES_URL ?? '';

  return initRuntimeConfigExtends(runtimeConfig as RuntimeConfigBase);
};

const { getInstance, setInstance, resetInstance } = makeSingleton(initRuntimeConfig);

export const getRuntimeConfig: () => RuntimeConfig = getInstance;
export const setRuntimeConfig = setInstance;
export const resetRuntimeConfig = resetInstance;
